module.exports = "<svg id=\"Layer_1\" style=\"enable-background:new 0 0 18.4 32.5;\" version=\"1.1\" viewbox=\"0 0 18.4 32.5\" x=\"0px\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\">\n\n<rect height=\"3\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 32.1924 33.3345)\" width=\"23\" x=\"-2.3\" y=\"21.8\"></rect>\n<rect height=\"3\" transform=\"matrix(-0.7071 -0.7071 0.7071 -0.7071 9.1924 22.1924)\" width=\"23\" x=\"-2.3\" y=\"7.7\"></rect></svg>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/arrow-right.icon.html
// module id = 183
// module chunks = 1